const MINUTE = 60 * 1000
const HOUR = 60 * MINUTE

export const toHumanizedValue = (milliseconds, unit) => {
  return milliseconds / (unit === 'hour' ? HOUR : MINUTE)
}

export const toMilliseconds = (humanizedValue, unit) => {
  return humanizedValue * (unit === 'hour' ? HOUR : MINUTE)
}

export const defaultUnit = (milliseconds) => {
  return _.isInteger(milliseconds / HOUR) ? 'hour' : 'minute'
}



// WEBPACK FOOTER //
// ./src/scripts/components/DelayTime/utils.js